import { render, staticRenderFns } from "./shouquan.vue?vue&type=template&id=7d60ce41&"
import script from "./shouquan.vue?vue&type=script&lang=ts&"
export * from "./shouquan.vue?vue&type=script&lang=ts&"
import style0 from "./shouquan.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports